import { PayloadAction } from "@reduxjs/toolkit";
import { IActivityHistoryUpFilter, isUpFilter } from "../../model";

export function setUpFilterValuesReducer(state, action: PayloadAction<string[]>) {
  state.filters = [...state.filters].map((f) => {
    if (isUpFilter(f)) {
      return { ...f, enabledValues: action.payload } as IActivityHistoryUpFilter;
    }
    return f;
  });
}
